export default __webpack_public_path__ + "static/media/Mennekes (Type 2).bc7fa45f.svg";